<template>
  <div>
    <el-page-header @back="goBack" :content="titleText + '-门票管理'" />
    <zx-table
      :tableData="tableData"
      :option="table"
      :page="page"
      @handleSelectionChange="handleSelectionChange"
      @delBtn="delBtn"
      @refresh-change="getlist"
      @refreshBtn="refreshBtn"
    ></zx-table>
  </div>
</template>

<script>
import * as ticket from "@/api/product/ticket.js";
import xzTable from "@/components/xz-table.vue";
export default {
  components: {
    "zx-table": xzTable
  },
  data() {
    return {
      page: {
        total: 1,
        pagerCount: 1,
        currentPage: 1,
        pageSize: 50,
        pageSizes: [15, 25, 30, 40, 50, 100],
        // sizes, prev, pager, next, jumper, ->, total, slot
        // "layout":"prev, pager, next",
        layout: "total, sizes, prev, pager, next, jumper",
        background: true
      },
      table: {
        title: "门票",
        // 表格底部按钮
        btnBottom: false,
        // 操作按钮列定位 默认:false;
        fixed: false,
        // 子表格 默认: ; 数据格式:String;<对应子行字段名称>
        children: "children",
        // 多选 默认:false;
        // selection: false,
        // 单选高亮
        current: true,
        //搜索框 默认:false;
        searchBtn: false,
        // 表格高度 默认:100%; 数据格式:Number;
        // height:500,
        // 数边框 默认:false;
        border: false,
        //索引 默认:true;
        index: true,
        // 刷新 默认:true;
        refreshBtn: true,
        // 添加 默认:true;
        addBtn: false,
        // 编辑 默认:true;
        editBtn: false,
        // 删除  默认:true;
        delBtn: true,
        // 折叠筐 默认:false;
        expand: false,
        column: [
          {
            prop: "ticket_name",
            label: "门票名称",
            type: "input",
            hide: true
          },
          {
            prop: "title",
            label: "区域名称",
            type: "input",
            hide: true
          },

          {
            prop: "thumb",
            label: "缩略图",
            type: "textarea",
            show: "image",
            hide: true
          },
          {
            prop: "play_date",
            label: "场次时间",
            type: "textarea",
            show: "img",
            hide: true
          },
          {
            prop: "price",
            label: "票面价格",
            type: "textarea",
            show: "img",
            hide: true
          },
          {
            prop: "is_sku",
            label: "库存模式",
            show: "tag",
            tagtype: [
              {
                text: "产品库存",
                type: "success",
                value: 0
              },
              {
                text: "日历库存",
                value: 1
              }
            ],
            hide: true
          },
          {
            layout: 12,
            prop: "status",
            label: "状态",
            type: "radio",
            show: "tag",
            default: 0,
            tagtype: [
              {
                text: "启用",
                type: "success",
                value: 0
              },
              {
                text: "禁用",
                type: "danger",
                value: 1
              }
            ],
            hide: true
          },

          {
            prop: "create_time",
            label: "创建时间",
            type: "input",
            hide: true,
            // 该字段是否可以在创建时编辑 默认:true;
            addDisplay: false,
            // 该字段是否可以修改默认true
            editDisplay: false
          }
        ],

        btnNavLeft: [
          {
            text: "添加",
            size: "mini",
            type: "success",
            click: () => {
              this.$router.push({
                path: "/product/addticket/" + 0,
                query: {
                  id: -1,
                  scenic_id: this.$route.query.id,
                  scenic_tit: this.$route.query.title
                }
              });
            }
          }
        ],
        btnList: [
          {
            name: "编辑",
            size: "mini",
            type: "text",
            click: (id, row, index) => {
              this.$router.push({
                path: "/product/addticket/" + row.scenic_id,
                query: {
                  id: this.$route.query.id,
                  ticket_id: row.ticket_id,
                  scenic_tit: this.$route.query.title
                }
              });
            }
          },
          //  {
          //   name: "日历库存",
          //   size: "mini",
          //   type: "text",
          //   click: (id, row, index)=> {
          //     this.$router.push({
          //       path: "/product/calendarInventory",
          //       query: {
          //         ticket_id: row.ticket_id
          //       }
          //     });
          //   }
          // },
          {
            name: "分销价格",
            size: "mini",
            type: "text",
            click: (id, row, index) => {
              this.$router.push({
                path: "/product/pricing/" + row.ticket_id,
                query: {
                  ticket_id: row.ticket_id,
                  ticket_title: row.title
                }
              });
            }
          },
          {
            name: "销售计划",
            size: "mini",
            type: "text",
            click: (id, row, index) => {
              this.$router.push({
                path: "/product/ticket/plan/" + row.ticket_id,
                query: {
                  ticket_id: row.ticket_id,
                  scenic_id: this.$route.query.id,
                  ticket_title: row.ticket_name + "(" + row.title + ")"
                }
              });
            }
          }
        ]
      },
      tableData: [],
      titleText: this.$route.query.title,
      id: this.$route.query.id
    };
  },
  created() {
    this.getlist();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    handleSubmit(form) {
      if (this.submitType === 1) {
        ticket.addScenic.r(form).then(res => {
          //   this.$message.success("部门《" + res.dept_name + "》创建成功");
          this.getlist();
        });
      } else if (this.submitType === 2) {
        ticket.editScenic.r(form).then(res => {
          this.$message.success("修改成功");
          this.getlist();
        });
      }
    },
    handleSuccess() {
      this.formData = {};
      this.dialogFormVisible = false;
    },
    // 删除
    delBtn(form) {
      // ticket.deleteScenic.r({ ticket_id: form.ticket_id }).then(res => {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          ticket.deleteTicket.r({ ticket_id: form.ticket_id }).then(res => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getlist();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //   多选
    handleSelectionChange(e) {},
    // 筛选条件
    searchSubmit(e) {
      this.searchData = e;
      if (e) {
        this.page.currentPage = 1;
      }
      this.getlist();
    },
    // 刷新
    refreshBtn(e) {
      this.getlist();
    },
    // 分页器
    refreshChange(e) {
      let that = this;
      setTimeout(() => {
        this.getlist();
      }, 1000);
    },
    getlist(e) {
      let param;
      let that = this;
      if (e) {
        that.page = e;
        param = {
          page: e.currentPage,
          limit: e.pageSize
        };
      } else {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize
        };
      }
      if (this.searchData) {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize,
          ...this.searchData
        };
      }
      param["scenic_id"] = this.id;
      ticket.getTicketList.r(param).then(res => {
        that.tableData = res.list;
        that.page.total = res.total;
      });
    }
  }
};
</script>
